import createRoutine from '@/utils/createRoutine'

export const showDocumentModalRoutine = createRoutine('showDocumentModalRoutine')
export const showHowItWorksModalRoutine = createRoutine('showDHowItWorksModalRoutine')
export const bookACallModalRoutine = createRoutine('bookACallModalRoutine')

export const showDocumentModalGetters = {
  SHOW_DOCUMENT_MODAL: 'SHOW_DOCUMENT_MODAL'
}

export const showHowItWorksModalGetters = {
  SHOW_HOW_IT_WORKS_MODAL: 'SHOW_HOW_IT_WORKS_MODAL'
}

export const bookACallModalGetters = {
  BOOK_A_CALL_MODAL_SEEN: 'BOOK_A_CALL_MODAL_SEEN'
}

export const SHOW_DOCUMENT_MODAL_CLEANUP = 'SHOW_DOCUMENT_MODAL_CLEANUP'
export const SHOW_HOW_IT_WORKS_MODAL_CLEANUP = 'SHOW_HOW_IT_WORKS_MODAL_CLEANUP'
export const BOOK_A_CALL_MODAL_CLEANUP = 'BOOK_A_CALL_MODAL_CLEANUP'
